import type { ReactElement } from 'react';
import { Button } from './button.jsx';
import type { BackProps } from './types.js';

/** Footer `<Back>` button. */
export const Back = ({
  icon = 'arrow-left',
  label = 'Back',
  ...props
}: BackProps): ReactElement => <Button {...{ icon, label, ...props }} />;
